const configuration = rawData => {
  const { expirationPollInterval = 60000 } = rawData
  return {
    expirationPollInterval,
    ...rawData,
  }
}

export default configuration
